import { render, staticRenderFns } from "./ExtendedSidebar.vue?vue&type=template&id=c52965a0"
import script from "./ExtendedSidebar.vue?vue&type=script&lang=ts"
export * from "./ExtendedSidebar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c52965a0')) {
      api.createRecord('c52965a0', component.options)
    } else {
      api.reload('c52965a0', component.options)
    }
    module.hot.accept("./ExtendedSidebar.vue?vue&type=template&id=c52965a0", function () {
      api.rerender('c52965a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sidebar/ExtendedSidebar.vue"
export default component.exports